import { once } from "es-toolkit/compat";
import { useRef } from "react";
import { sendUsage } from "utils/freemium";

export type UseShakeSilliesResult = {
  // Idempotent: fires `sendUsage("wiggle")` once per VM lifetime — called
  // from the first `play` action. Stubbable via `di={{ useVm }}` so storybook
  // doesn't POST `/api/beyond/usage`.
  recordUsage: () => void;
};

export function useShakeSillies(): UseShakeSilliesResult {
  // useRef holds a stable function reference across renders so consumers can
  // depend on `recordUsage` in useCallback without thrashing.
  const ref = useRef<UseShakeSilliesResult>();
  if (!ref.current) {
    ref.current = { recordUsage: once(() => sendUsage("wiggle")) };
  }
  return ref.current;
}
